import { NoticeTypes, ToastAlertTypes } from '@genial/components';

export const noticeBatchTicketRequests = [
  {
    text: 'Você poderá finalizar a boleta assim que o status estiver em ',
    variant: 'regular',
  },
  {
    text: 'A REVISAR',
    variant: 'bold',
  },
  {
    text: '. Por favor, clique em ATUALIZAR para acompanhar o status e finalize a boleta assim que possível.',
    variant: 'regular',
  },
] as NoticeTypes.TextObject[];

export const tableHeadBatchTicketRequestsData = [
  { title: 'ID solicitação' },
  { title: 'Data de envio' },
  { title: 'Tipo' },
  { title: 'Clientes', flex: 0.7 },
  { title: 'Ativos', flex: 0.7 },
  { title: 'Total estimado' },
  { title: 'Ult.atualização', flex: 1.2 },
  { title: 'Status', flex: 1.2 },
  { title: '' },
];

export const errorMessageBatchTicketRequestItem: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Ocorreu um erro ao recuperar informações desta solicitação,\nverifique sua conexão com a internet e\ntente novamente em instantes.',
];

export const successAddInteractionChannelMessage: [ToastAlertTypes.Type, string, string] = [
  'success',
  'Tudo certo!',
  'Foi adicionado o canal de solicitação a lista de produtos desta solicitação.',
];

export const successAddBillingTypeIdMessage: [ToastAlertTypes.Type, string, string] = [
  'success',
  'Tudo certo!',
  'Foi adicionado ao produto o tipo de boletagem.',
];

export const successReintegratedMessage: [ToastAlertTypes.Type, string, string] = [
  'success',
  'Tudo certo!',
  'O cliente foi reintegrado à lista de envio da boleta. Visualize os detalhes em “Resumo Total”.',
];

export const flatlistMaxH = '800px';
